import { Control, Controller, RegisterOptions } from "react-hook-form";
import { NGSwitch, NGSwitchProps } from "../../../../newcomponents/switch";

interface FormNGSwitchProps extends Omit<NGSwitchProps, "value" | "onChange"> {
  name: string;
  control: Control<any>;
  rules?: RegisterOptions;
}

export const FormNGSwitch = ({ name, control, rules, ...props }: FormNGSwitchProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <NGSwitch 
          {...props} 
          value={field.value || false} 
          onChange={(value) => field.onChange(value)} 
        />
      )}
    />
  );
};
